import { tv, VariantProps } from "@/utils";

export const mapWidget = tv({
  slots: {
    base: [
      "relative",
      "aspect-square",
      "rounded-lg",
      "overflow-hidden",
      "!outline-none",
    ],
    loader: ["flex items-center justify-center"],
  },
});

export type MapWidgetVariantProps = VariantProps<typeof mapWidget>;

export type MapWidgetReturnVariantProps = ReturnType<typeof mapWidget>;
